module.exports = __webpack_public_path__ + "media/dashboard/assets/images/account-01982f4e034a7ffc9df2941c5988fe0f.svg";